module.exports = __webpack_public_path__ + "static/media/logo-mha-white.f7d9f9d7.svg";